module.exports = __webpack_public_path__ + "static/img/hdgz.71570a96.png";